import React, { Component } from 'react';

class OccasionTriggerSlide extends Component {

  constructor(props) {
    super(props);
    this.state = {
      currentSlide: {},
      selectedValues: [],
      showNextBtn: true,
      showPrevBtn: false,
      isLastBtn: false,
      currentIndex: 0,
      // mainOccasions: [
      //   {
      //     label: 'Kid\'s Birthday',
      //     value: 'Kids Party',
      //     img: 'https://cdn.venuemonk.com/images/sliderform/birthday-party.png',
      //     altText: 'birthday-party',
      //   },
      //   {
      //     label: 'Team Party',
      //     value: 'Corporate Party',
      //     img: 'https://cdn.venuemonk.com/images/sliderform/team-party.png',
      //     altText: 'team-party',
      //   },
      //   {
      //     label: 'Wedding',
      //     value: 'Wedding',
      //     img: 'https://cdn.venuemonk.com/images/sliderform/wedding.png',
      //     altText: 'wedding',
      //   },
      //   {
      //     label: 'Cocktail Party',
      //     value: 'Cocktail Party',
      //     img: 'https://cdn.venuemonk.com/images/sliderform/cocktail-party.png',
      //     altText: 'cocktail-party',
      //   },
      //   {
      //     label: 'Corporate Events',
      //     value: 'Conference',
      //     img: 'https://cdn.venuemonk.com/images/sliderform/conference.png',
      //     altText: 'conference',
      //   },
      //   {
      //     label: 'Engagement',
      //     value: 'Engagement',
      //     img: 'https://cdn.venuemonk.com/images/sliderform/engagement.png',
      //     altText: 'engagement',
      //   },
      // ],
      mainOccasions: [
        {
          label: 'Wedding',
          value: 'Wedding',
          img: 'https://cdn.venuemonk.com/images/sliderform/wedding.png',
          altText: 'wedding',
        },
        {
          label: 'Engagement',
          value: 'Engagement',
          img: 'https://cdn.venuemonk.com/images/sliderform/engagement.png',
          altText: 'engagement',
        },
        {
          label: 'Corporate Party',
          value: 'Corporate Party',
          img: 'https://cdn.venuemonk.com/images/sliderform/team-party.png',
          altText: 'team-party',
        },
        {
          label: 'Cocktail Party',
          value: 'Cocktail Party',
          img: 'https://cdn.venuemonk.com/images/sliderform/cocktail-party.png',
          altText: 'cocktail-party',
        },
        {
          label: 'Reception',
          value: 'Reception',
          img: 'https://cdn.venuemonk.com/images/sliderform/cocktail-party.png',
          altText: 'reception',
        },
        {
          label: 'First Birthday Party',
          value: 'First Birthday Party',
          img: 'https://cdn.venuemonk.com/images/sliderform/birthday-party.png',
          altText: 'first-birthday-party',
        },
        {
          label: 'Birthday Party',
          value: 'Birthday Party',
          img: 'https://cdn.venuemonk.com/images/sliderform/cocktail-party.png',
          altText: 'birthday-party',
        },
        {
          label: 'Conference',
          value: 'Conference',
          img: 'https://cdn.venuemonk.com/images/sliderform/conference.png',
          altText: 'conference',
        },
        {
          label: 'Team Building Event',
          value: 'Team Building Event',
          img: 'https://cdn.venuemonk.com/images/sliderform/team-party.png',
          altText: 'team-building-party',
        },
        {
          label: 'Social Gathering',
          value: 'Social Gathering',
          img: 'https://cdn.venuemonk.com/images/sliderform/cocktail-party.png',
          altText: 'social-gathering',
        },
        {
          label: 'Pool Party',
          value: 'Pool Party',
          img: 'https://cdn.venuemonk.com/images/sliderform/cocktail-party.png',
          altText: 'pool-party',
        },
        {
          label: 'Meeting',
          value: 'Meeting',
          img: 'https://cdn.venuemonk.com/images/sliderform/cocktail-party.png',
          altText: 'meeting',
        },
        {
          label: 'Exhibition',
          value: 'Exhibition',
          img: 'https://cdn.venuemonk.com/images/sliderform/cocktail-party.png',
          altText: 'exhibition',
        },
        {
          label: 'Anniversary',
          value: 'Anniversary',
          img: 'https://cdn.venuemonk.com/images/sliderform/cocktail-party.png',
          altText: 'anniversary',
        },
      ],
    };
  }

  render() {
    return (
      <div className="">
        <div style={{backgroundColor: '#fff'}}>
          <h1 className="text-uppercase">{`Let's Plan Your Event`}</h1>
          <div style={{ background: 'var(--vm-primary-colour)', height: 5 }}/>
        </div>
        <div style={{ height: '100%' }}>
          <div style={{ height: `350px`, overflowX: 'hidden', overflowY: 'scroll' }}>
            <div>
              <div className="">
                {this.state.mainOccasions.map(item => (
                  <div
                    key={item.value}
                    className={item.isSelected ? `col-lg-4 col-xs-6 col-sm-6 btn vm-slider-btn occasion-slide vme-o-div active` :
                      `col-lg-4 col-xs-6 col-sm-6 btn vm-slider-btn occasion-slide vme-o-div`}
                    onClick={() => item.isSelected ? null : this.props.handleClick(item.value)}
                  >
                    <img className="sliderForm-img vme-o-img" src={item.img} alt={item.altText}/>
                    <div className="text-center vme-o-txt">{item.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default OccasionTriggerSlide;

